// extracted by mini-css-extract-plugin
export default {"wrapper":"wS-z","ratingContainer":"xS-z","ratingValue":"yS-z","starSprite":"zS-z","ratingLabel":"AS-z","error":"BS-z","errorBox":"CS-z"};